import {KeyboardSensor, PointerSensor, useSensor, useSensors} from "@dnd-kit/core";
import {sortableKeyboardCoordinates} from "@dnd-kit/sortable";

export const useSortableSensors = (activationDistance: number) =>
  useSensors(
    useSensor(PointerSensor, {activationConstraint: {distance: activationDistance}}),
    useSensor(KeyboardSensor, {coordinateGetter: sortableKeyboardCoordinates})
  );
